import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonModal,
  IonRefresher,
  IonRefresherContent,
  IonSegment,
  IonSegmentButton,
  IonSpinner,
  IonToolbar,
  RefresherEventDetail
} from "@ionic/react";
import { Eventcalendar } from "@mobiscroll/react";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import { closeCircleOutline } from "ionicons/icons";
import React, { useContext, useEffect, useState } from "react";
import { config } from "../../app.config";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { ApiService } from "../../services";
import { ViewportContext } from "../../utils/useViewport";
import { ViewEvent } from "./ViewEvent";
import { useLocation } from "react-router";
import { debug } from "../../App";

const EventsIndex = (props: any) => {
  const [eventIsOpen, setEventIsOpen] = useState<boolean>(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [filter, setFilter] = useState<string>("all");
  const { isMobile } = useContext(ViewportContext);
  const { showAllCalendarEvents } = useContext(AuthenticatedUserContext);
  const {hash} = useLocation();

  const dateFormat = config.format.date;
  const timeFormat = config.format.time;

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["events", "index", filter, showAllCalendarEvents],
    queryFn: () => {
      return ApiService.get("events?showAll=" + (showAllCalendarEvents ? "1" : "0") + "&filter=" + filter);
    },
  });

  useEffect(() => {
    if(hash && data?.data) {
      debug('Hash is set, trying to find event with id', hash);

      // remove the # from the hash
      const eventId = hash.replace('#', '');

      debug('Event ID = ' + eventId);

      // check that there is an event ID in the data
      const event = data.data.find((event: any) => event.id === parseInt(eventId));

      debug('Event = ' + event);

      // if so, then open the event
      if(event) {
        debug('Opening the event...');
        eventClick({event});
      }
    }
  }, [hash, data]);

  const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    refetch().then(event.detail.complete);
  };

  const eventClick = (clickEvent: any) => {
    setEventIsOpen(true);
    setSelectedEvent(clickEvent.event);
  };

  return (
    <BasicTemplate className="page--events" hideHeader={isMobile}>
      <IonModal isOpen={eventIsOpen} onDidDismiss={() => setEventIsOpen(false)} initialBreakpoint={0.5} breakpoints={[0, 0.5, 1]}>
        <IonButton
          fill={"clear"}
          className={"sheet-modal-close-button"}
          onClick={() => {
            setEventIsOpen(false);
          }}
        >
          <IonIcon icon={closeCircleOutline} />
        </IonButton>

        <ViewEvent
          event={selectedEvent}
          dateFormat={dateFormat}
          timeFormat={timeFormat}
          onSignUp={() => {
            const newEvent = { ...selectedEvent };
            newEvent.signed_up = true;
            newEvent.signups = newEvent.signups + 1;
            setSelectedEvent(newEvent);

            ApiService.put("events/" + selectedEvent.id + "/sign-up").then((response) => {
              setSelectedEvent(response.data);
              //presentToast("You are now going to this event.");
            });
          }}
          onUnSignUp={() => {
            const newEvent = { ...selectedEvent };
            newEvent.signed_up = false;
            newEvent.signups = newEvent.signups - 1;
            setSelectedEvent(newEvent);

            ApiService.delete("events/" + selectedEvent.id + "/sign-up").then((response) => {
              setSelectedEvent(response.data);
              //presentToast("You are no longer going to this event.");
            });
          }}
        />
      </IonModal>

      <IonHeader>
        <IonToolbar>
          <IonSegment
            value={filter}
            onIonChange={({ detail }) => {
              setFilter(detail.value || "all");
            }}
          >
            <IonSegmentButton value={"all"}>
              <IonLabel>{t("all")}</IonLabel>
            </IonSegmentButton>

            <IonSegmentButton value={"attending"}>
              <IonLabel>{t("attending")}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={true}>
        <IonRefresher slot={"fixed"} onIonRefresh={handleRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        {!isLoading && data ? (
          <Eventcalendar
            data={data.data}
            onEventClick={eventClick}
            themeVariant={"light"}
            dateFormat={dateFormat}
            timeFormat={timeFormat}
            view={{
              calendar: {
                type: "month",
                size: 1,
                labels: true,
              },
              agenda: {
                type: "month",
                size: 2,
              },
            }}
          />
        ) : (
          ""
        )}

        {isLoading && (
          <IonSpinner
            name={"dots"}
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        )}
      </IonContent>
    </BasicTemplate>
  );
};

export default EventsIndex;
